/**
 * Charge type values for pricing presets.
 * Indicates whether pricing is calculated per rental day or as a one-time charge.
 */
export enum ChargeTypeEnum {
	DAILY = 'daily',
	ONCE_OFF = 'once_off',
}
